<template>
  <Drawer
    width="800"
    :title="`${year}年${month}月-对账单-${customer?.name}`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <h1>{{ customer?.name }}</h1>
      <h1>{{year}}年{{month}}月</h1>
      <Row style="margin-top: 8px;">
        <Col span="8">
          <h3>对账单是否已收到</h3>
        </Col>
        <Col span="8">
          <RadioGroup v-model="duiZhangDanSigned">
            <Radio label="true" border>已收到</Radio>
            <Radio label="false" border>否</Radio>
        </RadioGroup>
        </Col>
      </Row>

      <!-- <Row style="margin-top: 8px;">
        <Col span="8">
          <h3>对账单是否有对方盖章</h3>
        </Col>
        <Col span="8">
          <RadioGroup v-model="duiZhangDanValid">
            <Radio label="true" border>有盖章</Radio>
            <Radio label="false" border>否</Radio>
        </RadioGroup>
        </Col>
      </Row> -->

      <Row style="margin-top: 8px;">
        <Col span="8">
          <h3>对账单上传</h3>
        </Col>
        <Col span="8">
          待开发
        </Col>
      </Row>
      
    </div>
  </Drawer>
</template>

<script>
import receive from "@/store/modules/receive";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "EditFactoryDrawer",
  components: {},
  data() {
    return {
      drawerOpened: false,
      year: -1,
      month: -1,
      customer: {},
      duiZhangDanSigned: "false",
      duiZhangDanValid: "false"
    };
  },
  computed: {
    ...mapGetters({
      semiMaterial: "material/semiMaterial",
    }),
  },
  methods: {
    ...mapActions({
      createFactory: "factory/createFactoryAction",
      updateFactory: "factory/updateFactoryAction",
      getMaterials: "material/getMaterialsAction",
    }),
    async openDrawer(customer, year, month) {
      this.customer = customer;
      this.month = month;
      this.year = year;
      this.drawerOpened = true;
    },
  },
};
</script>

<style scoped lang="stylus"></style>
